import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { Option } from "../types/table/interfaces.type";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export const fetchSmppScheduleDeliveryTimes = async (): Promise<string[]> => {
  try {
    const response = await axiosInstance.get("/smpp-schedule-delivery-time");
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching SMPP schedule delivery time options.",
    );
  }
};

export const useSmppScheduleDeliveryTimeQuery = (): UseQueryResult<
  Option[],
  Error
> => {
  return useQuery({
    queryKey: ["smppScheduleDeliveryTime", "all"],
    queryFn: async () => {
      const values = await fetchSmppScheduleDeliveryTimes();
      return values.map((value: string) => ({ label: value, value }));
    },
  });
};
